import React from "react";

const MARKS = [
  {
    src: "/ce.png",
    title: "CE",
    alt: "CE marking",
    text: "Conformité Européenne: the Auto Shiny Counter Dongle meets applicable EU harmonised requirements. See the EU Declaration of Conformity (DoC) in your language for details.",
  },
  {
    src: "/rohs.png",
    title: "RoHS",
    alt: "RoHS marking",
    text: "Restriction of Hazardous Substances in electrical and electronic equipment (EEE). The Auto Shiny Counter Dongle is placed on the market in line with applicable RoHS limits.",
  },
  {
    src: "/weee.png",
    title: "WEEE",
    alt: "WEEE symbol — crossed-out wheeled bin",
    text: "Do not dispose of the Auto Shiny Counter Dongle (or other EEE) as unsorted municipal waste. Use local collection, take-back, and recycling facilities.",
  },
];

const DECLARATIONS = [
  { file: "DoC_DE.pdf", label: "Deutsch (DE)" },
  { file: "DoC_FR.pdf", label: "Français (FR)" },
  { file: "DoC_ES.pdf", label: "Español (ES)" },
  { file: "DoC_PL.pdf", label: "Polski (PL)" },
  { file: "DoC_EN.pdf", label: "English (EN)" },
  { file: "DoC_PT.pdf", label: "Português (PT)" },
  { file: "DoC_CS.pdf", label: "Čeština (CS)" },
  { file: "DoC_SK.pdf", label: "Slovenčina (SK)" },
  { file: "DoC_HU.pdf", label: "Magyar (HU)" },
  { file: "DoC_RO.pdf", label: "Română (RO)" },
  { file: "DoC_BG.pdf", label: "Български (BG)" },
  { file: "DoC_EL.pdf", label: "Ελληνικά (EL)" },
  { file: "DoC_LT.pdf", label: "Lietuvių (LT)" },
];

export default function Compliance() {
  return (
    <div className="app-container">
      <div className="background-pattern"></div>

      <div className="main-content compliance-main">
        <div className="legal-header">
          <img
            src="/logo.png"
            alt="Auto Shiny Counter Logo"
            className="app-logo"
          />
          <h1 className="title">Certification &amp; Compliance</h1>
          <p className="legal-date">
            Certification and environmental information for the{" "}
            <strong>Auto Shiny Counter Dongle</strong> — EU Declaration of
            Conformity (PDF) by language.
          </p>
          <div className="compliance-icons-row" aria-label="CE, RoHS, WEEE">
            {MARKS.map(({ src, title, alt, text }) => (
              <figure key={src} className="compliance-icon-item">
                <img src={src} alt={alt} className="compliance-mark-img" />
                <figcaption>
                  <span className="compliance-mark-title">{title}</span>
                  <p className="compliance-mark-note">{text}</p>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        <div className="legal-content">
          <section className="legal-section">
            <h2>Declarations of Conformity</h2>
            <p>
              EU Declarations of Conformity for the{" "}
              <strong>Auto Shiny Counter Dongle</strong> — PDF downloads by
              language.
            </p>
            <ul className="compliance-doc-list">
              {DECLARATIONS.map(({ file, label }) => (
                <li key={file}>
                  <a href={`/${file}`} download className="compliance-doc-link">
                    {label}
                  </a>
                  <span className="compliance-doc-filename"> — {file}</span>
                </li>
              ))}
            </ul>
          </section>

          <section className="legal-section">
            <h2>Contact</h2>
            <p>
              Questions about these documents:{" "}
              <a href="mailto:sebastian-wagner-96@gmx.de?subject=Auto%20Shiny%20Counter%20%E2%80%93%20Declaration%20of%20Conformity">
                sebastian-wagner-96@gmx.de
              </a>
            </p>
          </section>
        </div>

        <div className="legal-footer">
          <a href="/" className="back-link">
            ← Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}
